import { CSSProperties } from 'styled-components';

export const QUERY_TABLE_CONFIG: CSSProperties = { width: 145 };
